export interface NamedTicketType {
  Id?: number;
  Name?: string | null;
}

export function canAddPositionsOfType(heldTicketTypeIds: number[] | null | undefined, ticketTypeId: number): boolean {
  const held = heldTicketTypeIds ?? [];
  return held.length === 0 || held.includes(ticketTypeId);
}

export function isMixedSection(heldTicketTypeIds: number[] | null | undefined): boolean {
  return (heldTicketTypeIds ?? []).length > 1;
}

export function heldTicketTypeNames(heldTicketTypeIds: number[] | null | undefined, ticketTypes: NamedTicketType[]): string {
  return (heldTicketTypeIds ?? [])
    .map(id => ticketTypes.find(t => t.Id === id)?.Name ?? `${id}`)
    .join(', ');
}
